import React from "react";
import { useUscOptionalLabel } from "../../../../utils/labels";
import { useUscSelector } from "../../../../redux/store";
import DescriptionLines from "../../common/DescriptionLines";
import Popover from "../../../../../../common-deprecated/components/popover/aem/lexus/Popover";
import { UscContext } from "../../../../../shared-logic/types/UscCommonTypes";
import { vehicleHasWarranty } from "../../../../../shared-logic/utils/uscUtils";
import Text from "../../styles/atoms/Text";
import Banner from "../../styles/molecules/Banner";
import { DfVehicleStatus } from "../../../../../shared-logic/utils/dfConstants";
import { getWarrantyBannerDescriptionItems } from "../../../../utils/helpers";

// In used cars this banner is used as a banner for describing the warranty
// The banner will be hidden when there is no valid warranty
// In stock cars there are no warranties so NMSC's are using this banner for other purposes.
const WarrantyBanner = (): JSX.Element | null => {
    const vehicle = useUscSelector((state) => state.vehicle);
    const uscSettings = useUscSelector((state) => state.uscSettings);
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const title = useUscOptionalLabel("uscPdpBannerTitle");

    // Hide warranty where is no valid warranty but only for used cars
    const hideWarranty = !vehicleHasWarranty(vehicle.result) && vehicle.type === UscContext.Used;
    const customerPromiseBanner = getWarrantyBannerDescriptionItems(
        uscSettings,
        vehicle.result,
        commonSettings.brand,
        vehicle.type,
        commonSettings,
    );

    if (!vehicle.result) return null;

    if (hideWarranty || !customerPromiseBanner?.bannerItems?.length) return null;

    const { bannerItems } = customerPromiseBanner;

    const isSold = vehicle.result?.vehicleStatus.code === DfVehicleStatus.Sold;
    if (isSold) return null;

    return (
        <Banner variant="warranty" title={title}>
            {bannerItems.length === 1 && (
                <Text tag="div" variant="paragraph-small-book">
                    {bannerItems[0].label}
                    {bannerItems[0].disclaimer && (
                        <>
                            <Popover showOnClick content={bannerItems[0].disclaimer} />
                        </>
                    )}
                </Text>
            )}
            {bannerItems.length > 1 && <DescriptionLines listItems={bannerItems} />}
        </Banner>
    );
};

export default WarrantyBanner;
